var _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "#F8F8FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    stroke: "#EBEBEB",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3172_23339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3172_23339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6673 26.3337V23.7712L24.2715 19.1878C24.3965 19.0628 24.5354 18.9725 24.6882 18.917C24.8409 18.8614 24.9937 18.8337 25.1465 18.8337C25.3132 18.8337 25.4729 18.8649 25.6257 18.9274C25.7784 18.9899 25.9173 19.0837 26.0423 19.2087L26.8132 19.9795C26.9243 20.1045 27.0111 20.2434 27.0736 20.3962C27.1361 20.5489 27.1673 20.7017 27.1673 20.8545C27.1673 21.0073 27.1395 21.1635 27.084 21.3232C27.0284 21.483 26.9382 21.6253 26.8132 21.7503L22.2298 26.3337H19.6673ZM20.9173 25.0837H21.709L24.2298 22.542L23.8548 22.1462L23.459 21.7712L20.9173 24.292V25.0837ZM13.0007 26.3337C12.5423 26.3337 12.15 26.1705 11.8236 25.8441C11.4972 25.5177 11.334 25.1253 11.334 24.667V11.3337C11.334 10.8753 11.4972 10.483 11.8236 10.1566C12.15 9.83019 12.5423 9.66699 13.0007 9.66699H19.6673L24.6673 14.667V17.167H23.0007V15.5003H18.834V11.3337H13.0007V24.667H18.0007V26.3337H13.0007ZM23.8548 22.1462L23.459 21.7712L24.2298 22.542L23.8548 22.1462Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.572d4f59fdb85ec307d16611205956b2.svg";
export { ForwardRef as ReactComponent };